export interface SignatureFlowNode {
    order: number;
    functie_id: number;
    functie_name: string;
    sign_type: number;  // 1=semnare, 2=aprobare, 3=confirmare, 4=olografică
    directie_id: number | null;
    directie_name: string | null;
    compartiment_id: number | null;
    compartiment_name: string | null;
    user_id: number | null;
    user_name: string | null;
}

export interface SignatureFlowData {
    template_id: number;
    template_name: string;
    document_type: string | null;
    is_address: boolean;
    is_dual: boolean;
    directie_id: number | null;
    directie_name: string | null;
    compartiment_id: number | null;
    compartiment_name: string | null;
    category_id: number | null;
    category_name: string | null;
    exemplar_complet: SignatureFlowNode[];
    exemplar_cetatean: SignatureFlowNode[];
}

export interface SignatureTypeConfig {
    icon: string;
    label: string;
    class: string;
}

export const SIGNATURE_TYPES: { [key: number]: SignatureTypeConfig } = {
    1: { icon: 'edit', label: 'Semnare', class: 'sign-type-semnare' },
    2: { icon: 'check_circle', label: 'Aprobare', class: 'sign-type-aprobare' },
    3: { icon: 'verified', label: 'Confirmare', class: 'sign-type-confirmare' },
    4: { icon: 'draw', label: 'Semnare Olografică', class: 'sign-type-olografica' }
};
